import React, { useState } from "react";
import { useAuth } from '../context/AuthContext';
import "./ConfidentialSupport.css"; 
import Footer from "./Footer";
import confidentialSupportBg from './image/confidential1.png';
import MbconfidentialSupportBg from './image/prrepx_confidential1.png';
import SocialSidebar from "../components/SocialSideBar";
import DishaChat from "../components/DishaChat";

function ConfidentialSupport() {
  // currentUser used by DishaChat internally; kept here in case future header needs it.
  useAuth();
  const [openFaqIndex, setOpenFaqIndex] = useState(null);

  const faqData = [
    { q: "What is this Confidential Support portal?", a: "This is your safe space for non-academic concerns — stress, motivation, time management, personal/family issues, or anything weighing on you. For academic doubts, please use our regular Doubt Portal." },
    { q: "Who is Disha?", a: "Disha is your personal mentor here at PrrepX Pathshala. She's available 24/7 to listen, support, and gently guide you through whatever you're feeling." },
    { q: "How soon can I expect a reply?", a: "Disha replies instantly in most cases. On rare occasions when she's helping many students at once, your message will be saved and answered as soon as she's free — usually within a few hours." },
    { q: "Is my conversation private?", a: "Yes — 100% private. Only you can see your chat with Disha. Your identity is never shared and your messages are encrypted in transit and at rest." },
    { q: "Where can I see my chat history?", a: "Your full conversation with Disha is right here on this page. Sign in with the same Google account to continue from where you left off, anytime." },
    { q: "Are there any limits?", a: "To keep this space healthy and personal, you can send up to 30 messages per day. If you need more, take a breath — Disha will be here tomorrow with fresh ears. ❤️" }
  ];

  const toggleFaq = (index) => setOpenFaqIndex(openFaqIndex === index ? null : index);

  return (
    <div className="page-wrapper">
      <SocialSidebar />

      {/* --- HERO SECTION MATCHING HOME PAGE --- */}
      <div className="cs-heroSection">
        <img src={confidentialSupportBg} alt="" className="cs-heroDesktopBg" />
        <div className="cs-heroGlow cs-glow1" />
        <div className="cs-heroGlow cs-glow2" />
        <div className="cs-heroGlow cs-glow3" />

        <div className="cs-heroMobileImg">
          <img src={MbconfidentialSupportBg} alt="Confidential Support" className="cs-heroMobileSlideImg" />
          <div className="cs-heroMobileImgBadge">❤️ 24/7 Confidential Support</div>
        </div>

        <div className="cs-heroContent">
          <div className="cs-heroBadgePill">❤️ 24/7 Confidential Support</div>
          <p style={{ fontWeight: 700, color: '#0f172a', margin: '0 0 4px 0' }}>For Personal & Mental Problems</p>
          <h1 className="cs-heroHeading">Your Safe Space for Non-academic Problems.</h1>
          <p className="cs-heroTagline">
            Feeling overwhelmed by preparation stress, dealing with a personal problem, or facing something you can't talk about with anyone else? We're here to listen, 100% privately.
          </p>
          
        </div>
      </div>

      {/* --- MODERN BODY --- */}
      <main className="cs-body">
        <section className="cs-chatSection">
          <div className="cs-chatIntro">
            <h2 className="cs-chatTitle">
              You're not alone — <span className="cs-chatTitleAccent">Ask Anything</span> 24*7
            </h2>
            <p className="cs-chatSub">
              Exam pressure, parents' expectations, self-doubt, burnout — every
              serious aspirant faces it. Share what's on your mind and get
              honest, judgment-free guidance from our mentor team. 100% private.
              Available 24×7.
            </p>
          </div>

          <div className="cs-chatCard">
            <DishaChat />
          </div>

          <div className="cs-trustRow">
            <div className="cs-trustItem">
              <span className="cs-trustIcon">🔒</span>
              <div>
                <strong>End-to-end private</strong>
                <span>Only you can read your chat</span>
              </div>
            </div>
            <div className="cs-trustItem">
              <span className="cs-trustIcon">🕒</span>
              <div>
                <strong>Available 24/7</strong>
                <span>Disha is here whenever you need</span>
              </div>
            </div>
            <div className="cs-trustItem">
              <span className="cs-trustIcon">🤗</span>
              <div>
                <strong>Zero judgment</strong>
                <span>Talk about anything, freely</span>
              </div>
            </div>
          </div>
        </section>

        <section className="cs-faqSection">
          <div className="cs-faqHead">
            <span className="cs-faqEyebrow">FAQ</span>
            <h2 className="cs-faqTitle">Things students often ask</h2>
          </div>
          <div className="cs-faqStack">
            {faqData.map((faq, index) => (
              <div
                key={index}
                className={`cs-faqItem ${openFaqIndex === index ? 'open' : ''}`}
              >
                <button
                  type="button"
                  className="cs-faqQ"
                  onClick={() => toggleFaq(index)}
                  aria-expanded={openFaqIndex === index}
                >
                  <span>{faq.q}</span>
                  <span className="cs-faqIcon" aria-hidden="true">+</span>
                </button>
                <div className="cs-faqA">
                  <div className="cs-faqAInner">{faq.a}</div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default ConfidentialSupport;